<div class="popup fullscreen" (click)="onBackgroundClick($event)">
  <div class="popup-content">
    <!-- 關閉按鈕 -->
    <button class="close-btn" (click)="close()">
      <i class="fas fa-times"></i>
      關閉
    </button>

    <!-- 法規基本資訊 -->
    <div class="law-info">
      <div class="law-header">
        <h2>
          <a [href]="data?.law_url" target="_blank" class="law-title-link">
            {{ data?.law_name || data?.law_title || '未設定' }}
            <i class="fas fa-external-link-alt"></i>
          </a>
        </h2>
      </div>

      <div class="law-details">
        <div class="detail-row">
          <strong>發布日期：</strong>
          <span>{{ data?.law_publish_date || '未設定' }}</span>
        </div>
        <div class="detail-row">
          <strong>修改日期：</strong>
          <span>{{ data?.law_modified_date || '未設定' }}</span>
        </div>
        <div class="detail-row">
          <strong>法規版本：</strong>
          <span>{{ data?.law_version || '未設定' }}</span>
        </div>
        <div class="detail-row">
          <strong>分類：</strong>
          <span>{{ data?.law_category || '未設定' }}</span>
        </div>
        <div class="detail-row">
          <strong>層級：</strong>
          <span>{{ data?.law_hierarchy || '未設定' }}</span>
        </div>
        <div class="detail-row">
          <strong>來源：</strong>
          <span>{{ getSourceWebsiteName(data?.law_url) }}</span>
        </div>
      </div>
    </div>

    <!-- 法條內容區域 -->
    <div class="article-content-section">
      <div class="article-header">
        <h3>
          <i class="fas fa-list-ol"></i>
          法條內容
          <span class="article-count">(共 {{ getActualLawCount() }} 條)</span>
        </h3>
      </div>

      <div class="article-content-area">
        <!-- 載入中狀態 -->
        <div *ngIf="isLoading && !hasError" class="loading-articles">
          <div class="loading-icon">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">載入中...</span>
            </div>
          </div>
          <p class="loading-message">正在載入法條內容...</p>
        </div>

        <!-- 錯誤狀態 -->
        <div *ngIf="hasError" class="error-articles">
          <div class="error-icon">
            <i class="fas fa-exclamation-triangle text-danger"></i>
          </div>
          <p class="error-message">{{ errorMessage || '載入法條內容時發生錯誤' }}</p>
          <button class="btn btn-outline-primary btn-sm" (click)="close()">
            <i class="fas fa-times"></i>
            關閉
          </button>
        </div>

        <!-- 有法條內容時顯示 -->
        <div *ngIf="!isLoading && !hasError && hasLawArticles()" class="articles-container">
          <div *ngFor="let article of getFilteredArticles()" class="article-item">
            <div class="article-header-item">
              <strong class="article-number">{{ article.article_no }}</strong>
            </div>
            <div class="article-content" [innerHTML]="formatArticleContent(article.article_content)"></div>
            <hr class="article-separator" />
          </div>
        </div>

        <!-- 沒有法條內容時顯示 -->
        <div *ngIf="!isLoading && !hasError && !hasLawArticles()" class="no-articles">
          <div class="no-articles-icon">
            <i class="fas fa-file-text"></i>
          </div>
          <p class="no-articles-message">目前沒有法條內容</p>
          <p class="no-articles-hint">
            <span *ngIf="data?.fetch_status === 'failed'">
              <i class="fas fa-exclamation-triangle text-warning"></i>
              法條內容擷取失敗
            </span>
            <span *ngIf="data?.fetch_status !== 'failed'">
              法條內容尚未載入或無內容
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
